import moment from 'moment'
import {
  SET_CONTACT_NAME,
  SET_INITIAL_TASK_DATA,
  EDIT_TASK_DATA,
  SET_NUMBER_OF_DUE_DATE_TASKS,
  SET_NUMBER_OF_TODAY_TASKS,
  SELECT_TASK,
  CHECK_ALL,
  SET_TASKS_SUMMARY,
  SET_TASK_FILTERS,
  EDIT_EVENT_DATA,
  EDIT_EVENT_DATA_FROM_TASK,
  SET_DATA_FOR_TASK_REPORT,
  GET_NOTES_FOR_TIMELINE,
  CLEAR_EVENT_DATA_FROM_TASK,
  CLEAR_EVENT_DATA,
  SET_EVENT_DATA_FROM_TASK,
  SET_TODAY_MEETING,
  RESET_ALL_DATA,
  IS_HAD_MEETING,
  SET_NEXT_WEEK_DATE,
  SET_LOADING,
  SET_TASK_EDITING,
  SET_TASK_COMPLETING,
  CLEAR_DASHBOARD_TASKS,
  GET_TASKS_FOR_DASHBOARD,
  RESET_TASKS_FILTERS,
  GET_USER_MONTHLY_TASK_STATISTIC,
  IS_SHARED_NOTE,
  EDIT_SHARED_NOTE_DATA,
} from './types'

const initialState = {
  data: {
    dueDate: moment().hours(17).minutes(0).format('MM/DD/YYYY hh:mm A'),
  },
  sharedNoteData: {},
  selectedTasks: [],
  taskFilters: {},
  timelineNotes: [],
  taskReportData: {},
  todayMeeting: {},
  eventDataFromTask: {
    meetingStart: '',
    meetingEnd: '',
    location: '',
    attendees: [],
  },
  eventData: {
    meetingStart: '',
    meetingEnd: '',
    location: '',
    attendees: [],
  },
  isHadMeeting: false,
  isSharedNote: false,
  isLoading: false,
  nextWeekDate: moment().add(7, 'days').format('MM/DD/YYYY hh:mm A'),
  isEditing: false,
  isCompleting: false,
  dashboardTasks: [],
  query: { first: 0, limit: 20, totalRecords: 0, hasMore: true, isRefresh: false },
  taskCreated: false,
  monthlyStatistic: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_ALL_DATA:
      return {
        ...state,
        data: {
          dueDate: moment().hours(17).minutes(0).format('MM/DD/YYYY hh:mm A'),
        },
        sharedNoteData: {},
        selectedTasks: [],
        taskFilters: { ...state.taskFilters },
        timelineNotes: [],
        taskReportData: {},
        todayMeeting: {},
        eventDataFromTask: {
          meetingStart: '',
          meetingEnd: '',
          location: '',
          attendees: [],
        },
        otherContactData: {},
        eventData: {
          meetingStart: '',
          meetingEnd: '',
          location: '',
          attendees: [],
        },
        numberOfTodayTasks: '',
        numberOfDueDateTasks: '',
        isHadMeeting: false,
        isSharedNote: false,
        isLoading: false,
        nextWeekDate: moment().add(7, 'days').format('MM/DD/YYYY hh:mm A'),
      }

    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }

    case SET_NEXT_WEEK_DATE:
      return {
        ...state,
        nextWeekDate: action.payload,
      }

    case IS_HAD_MEETING:
      return {
        ...state,
        isHadMeeting: action.payload,
      }

    case IS_SHARED_NOTE:
      return {
        ...state,
        isSharedNote: action.payload,
      }

    case SET_CONTACT_NAME:
      return {
        ...state,
        contactName: action.payload.name,
        otherContactData: action.payload,
        isLoading: false,
      }

    case SET_INITIAL_TASK_DATA:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
        sharedNoteData: {
          ...state.sharedNoteData,
          oldCrmNote: action.payload?.description?.replace(/<[^>]*>/g, '').replace(/\r?\n/g, '\\n') || '',
          note: action.payload?.description || null,
          subject: action.payload?.title,
        },
      }

    case EDIT_SHARED_NOTE_DATA:
      const { name: notePropName, value: notePropValue } = action.payload
      return {
        ...state,
        sharedNoteData: {
          ...state.sharedNoteData,
          [notePropName]: notePropValue,
        },
      }

    case EDIT_TASK_DATA:
      const { name, value } = action.payload
      return {
        ...state,
        data: { ...state.data, [name]: value },
      }

    case EDIT_EVENT_DATA:
      const { name: eventName, value: eventValue } = action.payload
      return {
        ...state,
        eventData: { ...state.eventData, [eventName]: eventValue },
      }

    case EDIT_EVENT_DATA_FROM_TASK:
      const { name: eventNameFromTask, value: eventValueFromTask } = action.payload
      return {
        ...state,
        eventDataFromTask: {
          ...state.eventDataFromTask,
          [eventNameFromTask]: eventValueFromTask,
        },
      }

    case CLEAR_EVENT_DATA_FROM_TASK:
      return {
        ...state,
        eventDataFromTask: {},
      }

    case CLEAR_EVENT_DATA:
      return {
        ...state,
        eventData: {
          meetingStart: '',
          meetingEnd: '',
          location: '',
          attendees: [],
        },
      }

    case SET_EVENT_DATA_FROM_TASK:
      return {
        ...state,
        eventDataFromTask: action.payload,
      }

    case SET_NUMBER_OF_DUE_DATE_TASKS:
      return {
        ...state,
        numberOfDueDateTasks: action.payload,
      }

    case SET_NUMBER_OF_TODAY_TASKS:
      return {
        ...state,
        numberOfTodayTasks: action.payload,
      }

    case SET_DATA_FOR_TASK_REPORT:
      return {
        ...state,
        taskReportData: action.payload,
      }

    case GET_NOTES_FOR_TIMELINE:
      return {
        ...state,
        timelineNotes: action.payload,
      }

    case SELECT_TASK:
      let checkedTasks = [...state.selectedTasks]
      if (!state.selectedTasks.includes(action.payload)) {
        checkedTasks.push(action.payload)
      } else {
        checkedTasks = checkedTasks.filter((i) => i !== action.payload)
      }
      return {
        ...state,
        selectedTasks: checkedTasks,
      }

    case CHECK_ALL:
      let checkedTasksAll = [...state.selectedTasks]
      if (checkedTasksAll.length === state.dashboardTasks.length) {
        checkedTasksAll = []
      } else {
        checkedTasksAll = state.dashboardTasks.map((i) => i.id)
      }
      return {
        ...state,
        selectedTasks: checkedTasksAll,
      }

    case SET_TASKS_SUMMARY:
      return {
        ...state,
        tasksSummary: action.payload,
      }

    case SET_TASK_FILTERS:
      const { name: filterName, value: filterValue } = action.payload
      return {
        ...state,
        taskFilters: { ...state.taskFilters, [filterName]: filterValue },
      }

    case SET_TODAY_MEETING:
      return {
        ...state,
        todayMeeting: action.payload,
      }

    case SET_TASK_EDITING:
      return {
        ...state,
        isEditing: action.payload,
      }

    case SET_TASK_COMPLETING:
      return {
        ...state,
        isCompleting: action.payload,
      }

    case CLEAR_DASHBOARD_TASKS: {
      return {
        ...state,
        dashboardTasks: [],
        query: initialState.query,
        taskFilters: {},
      }
    }

    case RESET_TASKS_FILTERS: {
      return {
        ...state,
        taskFilters: {},
      }
    }

    case GET_TASKS_FOR_DASHBOARD:
      return {
        ...state,
        dashboardTasks: action.payload.query.isRefresh
          ? [...action.payload.data]
          : [...state.dashboardTasks, ...action.payload.data],
        query: action.payload.query,
      }

    case GET_USER_MONTHLY_TASK_STATISTIC:
      return {
        ...state,
        monthlyStatistic: [...action.payload],
      }

    default:
      return state
  }
}
